module.exports = __webpack_public_path__ + "static/images/monet/back_drag_element.png";